module.exports = __webpack_public_path__ + "static/media/ondasV2.5a7b20b0.png";